import { useForm, Controller } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, TextField, MenuItem, InputAdornment, Typography } from "@material-ui/core";
import { basic, validationMessages, requiredOnly } from '../../../config/validations';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { internalSystem, blueprintWidth } from "../../../config/common";
import { createDelegate } from '../../../services/entities/delegate';
import { findRelativePosition } from '../../../services/reactFlowService';
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokePostService, invokeGetService } from '../../../store/global/actions';
import { findIconSource, generateIconFileName } from "../../../utils/commonUtils";

export const CreateUserForm = (props) => {
    const { onClose, onCompletion, clusterletDetails } = props;
    
    const { register, handleSubmit, formState: { errors }, control, setError, watch } = useForm();

    const nameValue = watch("name");

    const dispatch = useDispatch();
    const [clusterlets, setClusterlets] = useState([]);
    const [showDelegateInfo, setShowDelegateInfo] = useState('');
    const [icon, setIcon] = useState(null);
    const [noIcon, setNoIcon] = useState('')
    const [loading, setLoading] = useState(false);
    const [delegateTypes, setDelegateTypes] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    let delegates = clusterlets.filter(ele => ele.type === 1);

    const messages = {
        ...validationMessages,
        validate: 'Clusterlet with the given name exists'
    }

    // To remove the icon not selected warning, once the icon is selected
    useEffect(() => {
        if(icon){
            setNoIcon("");
        }
    }, [icon])

    useEffect(() => {
        setIsFetching(true);
        Promise.all([dispatch(invokeGetService('getDelegateProtocols', [])),
        dispatch(invokeGetService('getClusterlets', {}))]).then(([protocolResponse, clusterletResponse]) => {
            if (clusterletResponse?.status) setClusterlets(clusterletResponse.data);
            if (protocolResponse.status && protocolResponse.data) {
                const modifiedDelegateTypes = protocolResponse.data.map(item => ({label: item.schemaJson?.desc, value: item.node}));
                setDelegateTypes(modifiedDelegateTypes);
            }
            setIsFetching(false);
        });
	}, [])

    const onSave = (data) => {
        clusterletDetails.name = data.name;
        clusterletDetails.attributes.desc = data.description;

        if (icon == null) {
            setNoIcon('Please select an icon')
            return false
        }

        clusterletDetails.icon = generateIconFileName(icon);
        clusterletDetails.iconSource = findIconSource(icon);
        clusterletDetails.includeInViewMetaJson = true;
        const clusterletObj = JSON.parse(JSON.stringify(clusterletDetails))
        const position = findRelativePosition(clusterletDetails.position, clusterletDetails.type);
        clusterletObj.position = position;

        // clusterletDetails containing absolute position and clusterletObj containing relative position
        
        setLoading(true);
        
        
        let delegate = {};
        let isDelegateEdgeSource = false;  // For deciding delegate source/target when creating connection  
        const rightBorder = internalSystem.position.x + blueprintWidth;       // right border absolute poition
        const rightBorderRelativePos = (rightBorder / blueprintWidth) * 100;  // right border relative poition
        if (data?.delegate !== 'create') {
            delegate = {_id: data?.delegate};
            const delegateData = clusterlets.find(ele => ele._id === data?.delegate);
            isDelegateEdgeSource = delegateData?.position?.x < (rightBorderRelativePos / 2) ? true : false;  
        } else {
            delegate = createDelegate(`${data.name}_GW`, `${data.name} Gateway`, data.type, data.network, clusterletObj.position.x > (rightBorderRelativePos / 2) ? 'right' : 'left', delegates, clusterletDetails.position.y);   
            const reltive = findRelativePosition(delegate.position, delegate.type);
            delegate.position.y = reltive.y;
            delegate.position.x = reltive.x;
            isDelegateEdgeSource = delegate.position.x < (rightBorderRelativePos / 2) ? true : false;  
        }
        
        dispatch(invokePostService('createEnterpriseApp', {clusterlet: clusterletObj, delegate, isDelegateEdgeSource })).then(res => {
            setLoading(false);
            if (res?.status) {
                onCompletion(true);
            } else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
            }
        });

    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="description"
                    type={"text"}
                    fullWidth
                    rows={4}
                    label={"Description"}
                    placeholder={""}
                    variant="outlined"
                    multiline={true}
                    inputRef={register({ required: false, })}
                />
            </Grid>


            <Grid item xs={12} style={{ zIdex: 2000 }}>
                <Controller
                    name="delegate"
                    control={control}
                    rules={{ required: false }}
                    defaultValue={''}
                    render={({ field, onChange }) =>
                        <TextField
                            {...field}
                            label={'Associate a Delegate'}
                            name="delegate"
                            // required
                            select
                            fullWidth
                            variant={'outlined'}
                            onChange={e => { onChange(e); setShowDelegateInfo(e.target.value) }}
                            error={errors?.delegate ? true : false}
                            helperText={messages[errors?.delegate?.type] || ''}
                        >
                            <MenuItem key={'123'} value={''}>Associate a delegate</MenuItem>
                            <MenuItem key={'create'} value={'create'}>Create a delegate</MenuItem>
                            {clusterlets.filter(c => c.type === 1).filter(c => !c?.subType).map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                        </TextField>
                    }
                />
                <Typography style={{color: "gray", fontSize: '0.8rem', marginTop: '8px'}}>Choose a delegate, or leave empty to connect manually with Controller Delegate</Typography>
            </Grid>

            {showDelegateInfo === 'create' &&

                <>

                    <Grid item xs={12} style={{ zIdex: 2000 }}>
                        <Controller
                            name="type"
                            control={control}
                            rules={{ required: true, requiredOnly }}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    label={'Type'}
                                    name="type"
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={onChange}
                                    error={errors?.type ? true : false}
                                    helperText={messages[errors?.type?.type] || ''}
                                    SelectProps={{
                                        MenuProps: {
                                          MenuListProps: {
                                            id: "type-menu-list", 
                                          },
                                        },
                                      }}
                                    InputProps={{
                                        startAdornment: isFetching ? (
                                          <InputAdornment position="start" style={{width: "100%"}}>
                                            Loading types, please wait..
                                          </InputAdornment>
                                        ) : null,
                                      }}
                                >
                                    <MenuItem key={123} value={""}>Select type</MenuItem>
                                    {delegateTypes.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            }
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            name="network"
                            autoFocus
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Network"}
                            placeholder={""}
                            variant="outlined"
                            inputRef={register({ ...basic })}
                            error={errors?.network ? true : false}
                            helperText={errors?.network ? messages[errors?.network?.type] : ''}
                        />
                    </Grid>


                </>}

            <Grid item xs={12} >
                <IconSelector selectedIcon={icon} setSelectedIcon={setIcon} defaultSearchTag={nameValue}/>
            </Grid>

            {noIcon !== '' && <Grid item xs={12} style={{ color: 'red', marginTop: '-5px' }}>
                <p style={{font: 'inherit'}} >{noIcon}</p>
            </Grid>}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <CreateCancel createDisable={loading} content={loading ? 'Creating..' : 'Create'} onCreate={handleSubmit(onSave)} onCancel={onClose} />
            </Grid>
        </Grid>
    );

}